import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ReminderAndEscalationService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  public getReminderAndEscalationData(): Observable<any> {
    const url = this.apiUrl + 'ReminderAndEscalation/ReminderAndEscalation';
    return this.http.get<any>(url);
  }

  public getReminderAndEscalationDataBySearch(search: string = '', from: number = 0, size: number = 10, levels: number[] = [], orgCodes?: string): Observable<any> {
    let params = new HttpParams()
      .set('search', search)
      .set('from', from.toString())
      .set('size', size.toString());

    if (levels.length > 0) {
      params = params.set('levels', levels.join(','));
    }

    if (orgCodes) {
      params = params.set('orgCodes', orgCodes);
    }

    const url = this.apiUrl + 'ReminderAndEscalation/ReminderAndEscalationEmployeesBySearch';
    return this.http.get<any>(url, { params });
  }

  public exportReminderAndEscalationData(search: string = '', levels: number[] = [], orgCodes: string[] = []): Observable<any> {
    let params = new HttpParams().set('search', search);

    if (levels && levels.length > 0) {
    levels.forEach(level => {
      params = params.append('levels', level.toString());
    });
  }

  if (orgCodes && orgCodes.length > 0) {
    orgCodes.forEach(code => {
      params = params.append('orgCodes', code);
    });
  }
    const url = this.apiUrl + 'ReminderAndEscalation/ReminderAndEscalationExport';
    return this.http.get<any>(url, { params });
  }
  public getOrganizationCodes(): Observable<any[]> {
    const url = this.apiUrl + 'ReminderAndEscalation/GetDistinctOrgCodes';
    return this.http.get<any[]>(url);
  }
}
